exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".texto{\r\n  color: white;\r\n  text-shadow: 2px 2px 5px white;\r\n  font-weight: bold;\r\n  font-size: 1.2em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/loading/loading.component.css
// module id = ../../../../../src/app/components/loading/loading.component.css
// module chunks = main